module.exports = __webpack_public_path__ + "static/fourth_user_image5-fd776cc78fb3c1e9e69632bd70063fda.jpg";